<div
    fxLayout="column"
    class="report-beachmarking-section gap-12"
    [class.pdf-mode]="pdfMode"
>
    @if (loading || seriesBenchmark.length > 0) {
        <div class="series-benchmark-wrapper">
            <p
                [class.text-10-regular]="pdfMode"
                [class.text-14-regular]="!pdfMode"
                class="color-text-primary"
                style="margin-bottom: var(--spacing-12)"
            >
                Veja a avaliação comparativa da sua empresa com
                <span
                    [class.text-10-semi-bold]="pdfMode"
                    [class.text-14-semi-bold]="!pdfMode"
                    >a média do mercado:</span
                >
            </p>
            @if (!loading && !loadingBenchmarking) {
                <owl-carousel-o [options]="customOptions">
                    @for (benchmark of seriesBenchmark; track $index) {
                        <ng-template carouselSlide>
                            <div class="carousel-slide-benchmark">
                                <app-report-card-benchmark
                                    [benchmark]="benchmark"
                                    [locked]="locked"
                                    [pdfMode]="pdfMode"
                                ></app-report-card-benchmark>
                            </div>
                        </ng-template>
                    }
                    @if (!pdfMode) {
                        <ng-template
                            style="
                                width: 110px !important;
                                max-width: 110px !important;
                            "
                            [width]="110"
                            carouselSlide
                        >
                            <div
                                class="bencharming-more-info carousel-slide-benchmark cursor-pointer"
                                fxLayout="column"
                                fxLayoutAlign="center center"
                                (click)="onOpenBenchmarkingDialog()"
                            >
                                <dsn-button-rounded
                                    [type]="'primary'"
                                    [icon]="'fas fa-plus'"
                                    [size]="'medium'"
                                ></dsn-button-rounded>
                                <span
                                    class="text-14-semi-bold color-text-primary text-center"
                                    >Ver mais indicadores</span
                                >
                            </div>
                        </ng-template>
                    } @else {
                        <ng-template
                            style="
                                width: 90px !important;
                                max-width: 90px !important;
                            "
                            [width]="90"
                            carouselSlide
                        ></ng-template>
                    }
                </owl-carousel-o>
            } @else {
                <div fxLayout="row" fxLayoutAlign="start center" class="gap-8">
                    @for (item of [1, 2, 3]; track item) {
                        <dsn-skeleton-loader
                            [width]="'270px'"
                            [height]="'132px'"
                            [type]="'rectangle'"
                        ></dsn-skeleton-loader>
                    }
                    <dsn-skeleton-loader
                        [width]="'270px'"
                        [height]="'132px'"
                        [type]="'rectangle'"
                    ></dsn-skeleton-loader>
                </div>
            }
        </div>

        @if (!pdfMode) {
            @defer (when companyBenchmarking) {
                @if (
                    companyBenchmarking?.props.size ||
                    companyBenchmarking?.props.segmentGroup
                ) {
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <p class="text-12-regular color-text-primary">
                            Benchmark do CNAE
                            <span>
                                @if (
                                    companyBenchmarking?.props.sectorSubGroup
                                ) {
                                    <span class="text-12-semi-bold">
                                        {{
                                            companyBenchmarking?.props
                                                .sectorSubGroup
                                        }}
                                    </span>
                                }
                                @if (
                                    companyBenchmarking?.props.size &&
                                    companyBenchmarking?.props.sectorSubGroup
                                ) {
                                    e Porte
                                }
                                @if (companyBenchmarking?.props.size) {
                                    <span class="text-12-semi-bold">
                                        {{
                                            companyBenchmarking?.props.size
                                        }} </span
                                    >.
                                }
                            </span>
                        </p>

                        <div>
                            @if (!isMobile()) {
                                <div
                                    class="benchmark-data-source-info-desktop-wrapper"
                                >
                                    <div
                                        class="benchmark-data-source-info-desktop"
                                    >
                                        <i class="fa-solid fa-info-circle"></i>
                                        <span
                                            class="text-12-regular color-text-primary custom-tooltip-trigger"
                                            (mouseenter)="showTooltip = true"
                                            (mouseleave)="showTooltip = false"
                                            (click)="
                                                onOpenHelpCenterBenchmarking()
                                            "
                                        >
                                            Entenda de onde vêm os dados
                                            @if (showTooltip) {
                                                <div
                                                    class="custom-tooltip-popup"
                                                >
                                                    Os dados de benchmarking são
                                                    obtidos a partir da
                                                    comparação com empresas
                                                    presentes na base da Nucont.
                                                    <br />
                                                    <br />
                                                    São utilizadas empresas com
                                                    <strong>porte</strong> e
                                                    <strong
                                                        >atividade
                                                        econômica</strong
                                                    >
                                                    semelhantes à sua, conforme
                                                    o agrupamento de CNAEs, sem
                                                    distinção de região ou
                                                    estado.
                                                    <br />
                                                    <br />
                                                    <span
                                                        style="
                                                            font-style: italic;
                                                        "
                                                        >Caso seja necessário
                                                        alterar o porte e/ou o
                                                        CNAE, entre em contato
                                                        com o seu
                                                        contador.</span
                                                    >
                                                </div>
                                            }
                                        </span>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    @if (isMobile()) {
                        <div
                            class="benchmark-data-source-info-mobile"
                            (click)="onBenchmarkDataSource()"
                        >
                            <i
                                class="fa-solid fa-info-circle"
                                style="
                                    font-size: var(--font-size-14);
                                    color: var(--color-text-primary);
                                "
                            ></i>
                            <span class="text-12-regular color-text-primary">
                                Entenda de onde vêm os dados
                            </span>
                        </div>
                    }
                }
                @if (isMobile()) {
                    <img
                        class="cursor-pointer"
                        src="images/banner-benchmarking-mobile.png"
                        (click)="onRedirectToBenchmarking()"
                    />
                } @else {
                    <img
                        class="cursor-pointer"
                        src="images/banner-benchmarking.png"
                        (click)="onRedirectToBenchmarking()"
                    />
                }
            } @placeholder {
                <dsn-skeleton-loader
                    [width]="'200px'"
                    [height]="'20px'"
                    [type]="'rectangle'"
                ></dsn-skeleton-loader>
            }
        }
    }
</div>
